// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import translate from "@insite/client-framework/Translate";
import { getRoleTranslations } from "@vanmeter/App/Services/VmiUserService";
import { RoleTranslationModel } from "@vanmeter/App/Store/Reducers";

type Parameter = HasOnSuccess & HasOnError<string>;

type Props = {
    apiResult?: RoleTranslationModel[];
    error?: unknown;
};

type HandlerType = Handler<Parameter, Props>;

export const DispatchBeginLoadingRoleTranslations: HandlerType = props => {
    props.dispatch({ type: "xVmiUser/SetLoading", isLoading: true });
};

export const RequestDataFromApi: HandlerType = async props => {
    const result = await getRoleTranslations();

    if (result.successful) {
        props.apiResult = result.result;
    } else {
        props.error = result.errorMessage;
        props.parameter.onError?.(
            result?.errorMessage || translate("Something went wrong while loading VMI User Role Translations."),
        );
        props.dispatch({ type: "xVmiUser/SetLoading", isLoading: false });
        return false;
    }
};

export const DispatchCompleteLoadingRoleTranslations: HandlerType = props => {
    props.dispatch({
        type: "xVmiUser/CompleteLoading",
        roleLabels: props.apiResult,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.();
    }
};

export const chain = [
    DispatchBeginLoadingRoleTranslations,
    RequestDataFromApi,
    DispatchCompleteLoadingRoleTranslations,
    ExecuteOnSuccessCallback,
];

const loadVmiUserRoleTranslations = createHandlerChainRunner(chain, "loadVmiUserRoleTranslations ");
export default loadVmiUserRoleTranslations;
